
export default function pageAddEventListener () {
  /** 滚动监听 */
  window.addEventListener('scroll', function(event) {
    // console.log(111);
    let myPopoverArr = document.getElementsByClassName('medicalEditor_my-popover') || []
    // console.log(myPopoverArr);
    for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
      myPopoverArr[popIndex].classList.remove('divBlock')
    }
  },false)
  /* 点击监听 */
  let medicalEditor_drug_detail_addScrollEvents = document.getElementById('app')
  medicalEditor_drug_detail_addScrollEvents.addEventListener('click',function(event) {
    let myPopoverArr = document.getElementsByClassName('medicalEditor_my-popover') || []
    // console.log(myPopoverArr);
    for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
      myPopoverArr[popIndex].classList.remove('divBlock')
    }
  },false)
}



// WEBPACK FOOTER //
// ./src/utils/eventListener.js